import { BaseStore } from "../extends/base-store";
import { ImasterContent } from "../interfaces/imaster-content";

export class ValoresDonarStore extends BaseStore {
  objValores: Array<ImasterContent> = [];
  /**
   * @author Jose Wilson Mulato
   * @description Obtener valores por defecto a donar
   */
  protected async GetService() {
    
    this.objValores = [
      { descParametro: 'Aporte libre', consParametro: '-1', valor: '-1' }, 
      { descParametro: '1 día de salario', consParametro: '1 día de salario', valor: '1 día de salario' }, 
      { descParametro: '2 días de salario', consParametro: '2 días de salario', valor: '2 días de salario' }, 
      { descParametro: '3 días de salario', consParametro: '3 días de salario', valor: '3 días de salario' },
      { descParametro: '1 día de vacaciones', consParametro: '1 día de vacaciones', valor: '1 día de vacaciones' },
      { descParametro: '2 días de vacaciones', consParametro: '2 días de vacaciones', valor: '2 días de vacaciones' },
      { descParametro: '3 días de vacaciones', consParametro: '3 días de vacaciones', valor: '3 días de vacaciones' }
    ];
    
    /*
    this.objValores = [
      { descParametro: 'Aporte libre', consParametro: '-1', valor: '-1' }, 
      { descParametro: '1 día de salario', consParametro: '1 día de salario', valor: '1 día de salario' }, 
	    { descParametro: '2 días de salario', consParametro: '2 días de salario', valor: '2 días de salario' }, 
	    { descParametro: '3 días de salario', consParametro: '3 días de salario', valor: '3 días de salario' }
    ];
    */

    this.objValores.forEach(x =>
      this.Data.push({ Label: x.descParametro, Value: x.consParametro })
    );
    return;
  }
}



// WEBPACK FOOTER //
// ./src/app/store/valores-donar-store.ts